import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
export { DEFAULT_BREAKPOINTS } from './constants';
export const adjustBreakpointHeight = (breakpoints, heightDelta)=>breakpoints.map((point)=>_object_spread_props(_object_spread({}, point), {
            elementHeight: point.elementHeight + heightDelta
        }));
export const createGridBreakpoint = ({ screenWidth: maxWidth , containerWidth , elementSpacing , elementHeight , elementsPerRow  })=>({
        maxWidth,
        elementWidth: (containerWidth + elementSpacing) / (elementsPerRow + elementSpacing) - elementSpacing,
        elementHeight
    });
